var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E39B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.245 11.4602C29.8582 11.0131 29.3161 10.7296 28.7283 10.6668C26.1561 10.3973 23.6519 9.67448 21.3317 8.53183C21.034 8.3856 20.7067 8.30957 20.375 8.30957C20.0433 8.30957 19.716 8.3856 19.4183 8.53183C17.1151 9.67569 14.626 10.3987 12.0683 10.6668C11.4799 10.7183 10.931 10.9846 10.5264 11.415C10.1219 11.8454 9.88996 12.4097 9.875 13.0002V18.8335C9.875 26.6968 17.75 31.6668 20.375 31.6668C23 31.6668 30.875 26.7085 30.875 18.8335V13.0002C30.8614 12.4269 30.6371 11.8786 30.245 11.4602ZM24.7033 18.4602L20.0367 23.1268C19.9282 23.2362 19.7992 23.323 19.657 23.3822C19.5148 23.4414 19.3623 23.4719 19.2083 23.4719C19.0543 23.4719 18.9018 23.4414 18.7597 23.3822C18.6175 23.323 18.4885 23.2362 18.38 23.1268L16.0467 20.7935C15.827 20.5738 15.7036 20.2758 15.7036 19.9652C15.7036 19.6545 15.827 19.3565 16.0467 19.1368C16.2664 18.9171 16.5643 18.7937 16.875 18.7937C17.1857 18.7937 17.4836 18.9171 17.7033 19.1368L19.2083 20.6885L23.0467 16.8385C23.2664 16.6188 23.5643 16.4954 23.875 16.4954C24.1857 16.4954 24.4836 16.6188 24.7033 16.8385C24.923 17.0582 25.0464 17.3561 25.0464 17.6668C25.0464 17.9775 24.923 18.2755 24.7033 18.4952V18.4602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/Insurance.95f56a09d185be4ea62424da1c94ebdf.svg";
export { ForwardRef as ReactComponent };